<template>
  <div id="sidebarComponent">
    <div class="top">
      <div class="icon">
        <p class="iconIn" style="width: 1.35rem;height: 0.5rem">
          <img src="../../public/img/icons/loge_black.png" alt="">
        </p>
      </div>
      <p class="name">HOVEY WORKS</p>
    </div>
    <div class="center">
      <div v-show="navShow" class="animate__animated animate__fadeIn">
        <nav v-for="item in navNameList" :key="item.navVal">
          <p v-wave :class="[ item.navStatus ? 'navName_active' : 'navName_default', 'navName' ]" @click="navChange(item)">
            <i :class="item.navIcon"/>{{ $t(item.navName) }}
          </p>
        </nav>
      </div>
      <div v-show="!navShow" class="animate__animated animate__fadeIn">
        <configurationName></configurationName>
        <div class="configChange">
          <el-popover
            placement="right"
            :title="$t('说明')"
            width="350"
            trigger="hover">
            <div>
              <p style="line-height: 0.25rem">
                {{$t('提示内容61')}}
              </p>
            </div>
            <i slot="reference" class="el-icon-info" style="color: #FF9A00;font-size: 0.2rem;"></i>
          </el-popover>
        </div>
      </div>
    </div>
    <div v-show="navShow" class="bottom animate__animated animate__fadeIn">
      <p class="buttonBox">
        <el-button class="helpButton" v-wave type="primary" icon="el-icon-chat-dot-round" circle @click="drawerOpen('1')"></el-button>
      </p>
      <p class="buttonBox">
        <el-button class="settingButton" v-wave type="primary" icon="el-icon-setting" circle @click="drawerOpen('2')"></el-button>
      </p>
    </div>
    <div v-show="!navShow" class="bottom animate__animated animate__fadeIn">
      <el-button class="quitButton" type="primary" icon="el-icon-caret-left" @click="quitKey">{{ $t('退出') }}</el-button>
      <el-button class="quitButton" type="primary" icon="el-icon-s-tools" @click="drawerOpen('3')">{{ $t('设置') }}
        <el-popover v-if="updatePrompt"
          placement="right"
          :title="$t('提示')"
          width="350"
          trigger="hover">
          <div>
            <p style="line-height: 0.25rem">
              {{$t('提示内容78')}}
            </p>
          </div>
          <i slot="reference" class="el-icon-warning" style="color: #FF9A00;font-size: 0.2rem;"></i>
        </el-popover>
      </el-button>
    </div>
    <div class="drawer">
      <el-drawer
          :title="drawerTitle"
          size="70%"
          :visible.sync="drawer"
          direction="rtl"
          :before-close="handleClose">
        <div class="drawerBox">
          <div id="settingPart" v-show="drawerCom === 'keySettingPart'">
            <div class="content">
              <div class="contentBox">
                <h5>{{ $t('版本信息') }}</h5>
                <p class="renewalBox">
                  <span class="editionNum">{{ $t('固件版本') }}：{{firmwareVersion}}</span>
                  <el-button v-wave type="primary" size="mini" round icon="el-icon-refresh-right" @click="openDialog">{{ $t('固件更新') }}</el-button>
                </p>
              </div>
              <div class="contentBox">
                <h5>{{ $t('设备信息') }}</h5>
                <p class="renewalBox">
                  <span class="editionNum">{{ $t('设备名称') }}：{{productName}}</span>
                  <span class="editionNum">{{ $t('设备序列号') }}：{{serialNumber}}</span>
                </p>
              </div>
            </div>
          </div>
          <div id="settingPart" v-show="drawerCom === 'settingPart'">
            <div class="content">
<!--              <div class="contentBox">-->
<!--                <h5>主题</h5>-->
<!--                <p class="radioBox">-->
<!--                  <el-radio v-model="themeRadio" label="1" @change="themeRadioChange('1')">亮色主题</el-radio>-->
<!--                  <el-radio v-model="themeRadio" label="2" @change="themeRadioChange('2')">暗色主题</el-radio>-->
<!--                </p>-->
<!--              </div>-->
              <div class="contentBox">
                <h5>{{ $t('版本信息') }}</h5>
                <p class="renewalBox">
                  <span class="editionNum">{{ $t('驱动版本') }}：0.0.7</span>
                </p>
              </div>
              <div class="contentBox">
                <h5>{{ $t('语言设置') }}</h5>
                <p class="renewalBox">
                  <el-radio-group v-model="languageRadio" @input="languageRadioChange">
                    <el-radio label="zh">简体中文</el-radio>
                    <el-radio label="en">English</el-radio>
                    <el-radio label="jpn">日本語</el-radio>
                  </el-radio-group>
                </p>
              </div>
            </div>
          </div>
<!--          todo  服务信息备案号更改为 zent -->
          <div id="helpPart" v-show="drawerCom === 'helpPart'">
            <div class="content">
              <div class="contentBox">
                <h5>{{ $t('更多服务') }}</h5>
                <p class="des">{{ $t('服务提醒') }}</p>
                <p class="radioBox">
                  <el-link href="https://www.woblab.cn" target="_blank">www.woblab.cn</el-link>
                </p>
              </div>
              <div class="contentBox">
                <h5>{{ $t('联系我们') }}</h5>
                <div class="renewalBox">
                  <el-row>
                    <el-popconfirm
                      :confirm-button-text="$t('复制')"
                      :cancel-button-text="$t('取消')"
                      icon="el-icon-info"
                      :title="$t('电话') + ': ' + copyText.phone"
                      @confirm="copyTextCon('0')"
                    >
                      <el-button v-wave type="primary" icon="el-icon-phone-outline" circle slot="reference"></el-button>
                    </el-popconfirm>
                    <el-popconfirm
                      :confirm-button-text="$t('复制')"
                      :cancel-button-text="$t('取消')"
                      icon="el-icon-info"
                      :title="$t('邮箱') + ': ' + copyText.email"
                      @confirm="copyTextCon('1')"
                    >
                      <el-button v-wave type="primary" icon="el-icon-chat-line-square" circle slot="reference"></el-button>
                    </el-popconfirm>
                    <el-popconfirm
                      :confirm-button-text="$t('复制')"
                      :cancel-button-text="$t('取消')"
                      icon="el-icon-info"
                      :title="$t('Q群') + ': ' + copyText.customerServiceGroup"
                      @confirm="copyTextCon('2')"
                    >
                      <el-button v-wave type="primary" icon="el-icon-message" circle slot="reference"></el-button>
                    </el-popconfirm>
                  </el-row>
                </div>
              </div>
              <div class="contentBox">
                <h5>备案号</h5>
                <p class="des">
                  <a href="https://beian.miit.gov.cn/" target="_blank">赣ICP备2024040482号</a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </el-drawer>
    </div>
    <el-dialog
      :title="$t('固件更新')"
      :visible.sync="renewalDialogVisible"
      width="50%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      center>
      <div>
        <firmwareDownload :productId="productId"></firmwareDownload>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import EventBus from '@/store/eventBus'
import configurationName from '../components/configurationName.vue'
import firmwareDownload from "@/components/firmwareDownload.vue";
export default {
  name: "sidebarComponent",
  components: {
    configurationName,
    firmwareDownload
  },
  data() {
    return {
      languageRadio: 'zh',
      renewalDialogVisible: false,
      navShow: true,
      navNameList: [
        {
          navName: '我的键盘',
          navVal: '0',
          navStatus: true,
          navIcon: 'el-icon-place',
          navUrl: '/keyboard'
        },
        // {
        //   navName: '键盘工具',
        //   navVal: '1',
        //   navStatus: false,
        //   navIcon: 'el-icon-help',
        //   navUrl: '/keyboardTools'
        // },
        {
          navName: '更新日志',
          navVal: '2',
          navStatus: false,
          navIcon: 'el-icon-notebook-2',
          navUrl: '/keyboard'
        }
      ],
      drawer: false,
      drawerTitle: '',
      drawerCom: '',
      themeRadio: '',
      serialNumber: '',
      productName: '',
      productId: null,
      firmwareVersion: '',
      isConnected: false,
      copyText: {
        phone: '13249802938',
        email: '1799515183@qq.com',
        customerServiceGroup: '992610087'
      }, // 复制到剪切板的文本
      fileList: [
        {
          fileName: '0.0.18',
        }
      ]
    }
  },
  computed: {
    updatePrompt() {
      if (this.productId === 13694) {
        return this.firmwareVersion !== this.fileList[0].fileName;
      } else {
        return false
      }
    }
  },
  mounted() {
    EventBus.$on('enterKeyboard',this.handleEnterKeyboard)
    EventBus.$on('serialNumber',this.handleSerialNumber)
    EventBus.$on('getProductName',this.getProductName)
    EventBus.$on('getFirmwareVersion',this.getFirmwareVersion)
    EventBus.$on('themeChange',this.handleThemeChange)
    EventBus.$on('connected', this.getConnectedResult)
    let language = localStorage.getItem('language')
    if (language && ['en','zh','jpn'].includes(language)) {
      this.$i18n.locale = language
      this.languageRadio = language
    } else {
      this.$i18n.locale = 'zh'
    }
  },
  methods: {
    languageRadioChange() {
      this.$i18n.locale = this.languageRadio  // 切换语言
      localStorage.setItem('language', this.languageRadio)
    },
    copyTextCon(val) {
      let text = ''
      switch (val) {
        case '0':
          text = this.copyText.phone
          break;
        case '1':
          text = this.copyText.email
          break;
        case '2':
          text = this.copyText.customerServiceGroup
          break;
      }
      navigator.clipboard.writeText(text).then(() => {
        this.$message({
          message: this.$t('复制成功'),
          type: 'success'
        })
      }).catch(err => {
        console.error('复制失败: ', err);
      })
    },
    // 获取键盘连接状态回调
    getConnectedResult(val) {
      this.isConnected = val
    },
    openDialog() {
      if (this.isConnected) {
        this.renewalDialogVisible = true
      } else {
        this.$notify.info({
          title: this.$t('提示'),
          message: this.$t('提示内容1'),
          offset: 100
        })
      }
    },
    handleThemeChange(val) {
      if (val === 'dark') {
        this.themeRadio = '2'
      } else {
        this.themeRadio = '1'
      }
    },
    handleEnterKeyboard(data) {
      this.navShow = false
      this.productId = data.productId
    },
    // 回到主页面
    quitKey() {
      this.navShow = true
      EventBus.$emit('quitKeyboard')
    },
    navChange(obj) {
      this.navNameList.forEach( e => {
        if (e.navVal === obj.navVal) {
          e.navStatus = true
          EventBus.$emit('navChange',e.navVal)
        } else {
          e.navStatus = false
        }
      })
    },
    drawerOpen(val) {
      this.drawer = true
      if (val === '1') {
        this.drawerTitle = this.$t('帮助')
        this.drawerCom = 'helpPart'
      } else if (val === '2') {
        this.drawerTitle = this.$t('设置')
        this.drawerCom = 'settingPart'
      } else {
        this.drawerTitle = this.$t('键盘设置')
        this.drawerCom = 'keySettingPart'
        EventBus.$emit('getSettingPartData')
      }
    },
    handleClose(done) {
      done();
    },
    handleSerialNumber(val) {
      this.serialNumber = val
    },
    getProductName(val) {
      this.productName = val
    },
    getFirmwareVersion(val) {
      this.firmwareVersion = val.firmwareVersion
    },
    themeRadioChange(val) {
      if (val === '1') {
        window.document.documentElement.setAttribute('data-theme', 'light')
        localStorage.setItem('data-theme', 'light')
      } else {
        window.document.documentElement.setAttribute('data-theme', 'dark')
        localStorage.setItem('data-theme', 'dark')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../style/handle.scss';
  #sidebarComponent {
    width: 100%;
    height: 100%;
    @include background_color('background_color_sidebar');
    border-radius: 0 0.2rem 0.2rem 0;
    transition: all 0.3s;
    box-shadow: 0 0.05rem 0.12rem rgba(0,0,0,0.5);
    .top {
      width: 100%;
      //height: 100px;
      padding-top: 0.7rem;
      text-align: -webkit-center;
      .name {
        margin: 0.1rem 0;
        font-size: 0.16rem;
        @include font_color('font_color');
      }
      .icon {
        .iconIn {
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
    .center {
      width: 100%;
      height: calc(100% - 2.5rem);
      padding-top: 0.4rem;
      nav {
        height: 0.6rem;
        padding: 0.05rem 0.2rem;
      }
      .configChange {
        display: flex;
        justify-content: center;
        margin-top: 0.2rem;
      }
      .navName {
        height: 100%;
        font-size: 0.2rem;
        @include font_color('font_color');
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 0.3rem;
        i {
          margin-right: 0.1rem;
        }
      }
      .navName_default:hover {
        @include background_color('background_color_hover')
      }
      .navName_active {
        background: #409EFF;
        @include font_color('font_color_active')
      }
    }
    .bottom {
      display: flex;
      justify-content: space-between;
      padding: 0 0.2rem;
      /deep/.buttonBox {
        .el-button {
          font-size: 0.14rem;
          padding: 0.12rem 0.2rem;
          border-radius: 0.04rem;
        }
        .helpButton {
          //padding: 0.2rem;
          //font-size: 0.2rem;
          background-color: #5546FF;
          border-color: #5546FF;
        }
        .settingButton {
          //padding: 0.2rem;
          //font-size: 0.2rem;
          background-color: #FF1E7D;
          border-color: #FF1E7D;
        }
      }
    }
    .quitButton {
      width: 100%;
      padding: 0.1rem 0.2rem;
      font-size: 0.2rem;
    }
    /deep/.drawer {
      .el-drawer__open .el-drawer.rtl {
        @include background_color('background_color_main');
        @include font_color('font_color');
        .el-drawer__header {
          @include font_color('font_color');
          font-size: 0.2rem;
          margin-bottom: 0.32rem;
          padding: 0.2rem 0.2rem 0;
          .el-drawer__close-btn {
            font-size: 0.2rem;
          }
        }
      }
      #settingPart {
        width: 100%;
        height: 100%;
        border-radius: 0.1rem;
        padding: 0.2rem 0.3rem;
        @include font_color('font_color');
        .content {
          .contentBox {
            margin-bottom: 0.4rem;
            h5 {
              font-size: 0.2rem;
            }
            .radioBox {
              margin-top: 0.2rem;
            }
            .renewalBox {
              margin-top: 0.2rem;
              font-size: 0.14rem;
              .editionNum {
                display: inline-block;
                margin-right: 0.5rem;
              }
              .el-button--mini.is-round {
                padding: 0.07rem 0.15rem;
                font-size: 0.14rem;
                border-radius: 0.2rem;
              }
              .el-button [class*=el-icon-]+span {
                margin-left: 0.05rem;
              }
            }
          }
        }
      }
      #helpPart {
        width: 100%;
        height: 100%;
        border-radius: 0.1rem;
        padding: 0.2rem 0.3rem;
        @include font_color('font_color');
        .content {
          .contentBox {
            margin-bottom: 0.4rem;
            h5 {
              font-size: 0.2rem;
            }
            .des {
              font-size: 0.15rem;
              padding-top: 0.1rem;
              margin-top: 0.2rem;
              a,a:link,a:visited,a:hover,a:active{
                text-decoration: none;
                color: #888;
                font-size: 0.16rem !important;
              }
            }
            .radioBox {
              .el-link {
                margin-right: 0.4rem;
                font-size: 0.16rem;
              }
            }
            .renewalBox {
              margin-top: 0.2rem;
              font-size: 0.14rem;
              .editionNum {
                display: inline-block;
                margin-right: 0.5rem;
              }
              .el-row {
                .el-button {
                  margin: 0 0.3rem;
                  font-size: 0.14rem;
                  padding: 0.12rem 0.12rem;
                }
              }
            }
          }
        }
      }
    }
    /deep/.el-dialog {
      margin: 0 auto 0.5rem;
      border-radius: 0.02rem;
      .el-dialog__header {
        padding: 0.2rem 0.2rem 0.1rem;
        .el-dialog__title {
          font-size: 0.18rem;
          line-height: 0.24rem;
        }
        .el-dialog__headerbtn {
          top: 0.2rem;
          right: 0.2rem;
          font-size: 0.16rem;
        }
      }
      .el-dialog__body {
        padding: 0.25rem 0.25rem 0.3rem;
        font-size: 0.14rem;
        .el-button {
          font-size: 0.14rem;
          padding: 0.12rem 0.2rem;
          border-radius: 0.04rem;
        }
      }
      .el-dialog__footer {
        .el-button {
          font-size: 0.14rem;
          padding: 0.12rem 0.2rem;
          border-radius: 0.04rem;
        }
      }
    }
  }
</style>
